module.exports = __webpack_public_path__ + "media/images/bangs-2adfc2181d557de9af4ca347a4275d79.png";